import {Component, Injectable, Input, OnInit,OnChanges, Output, EventEmitter } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap, finalize} from 'rxjs/operators';
import { PRODUCT_CONFIG, SUBMISSION_MSGS } from 'src/app/_common/product-config';
import { SubmissionSteps, DandBEventsTypes, ThirdPartyNames } from '../../_common/_enum/module.enum';
import { SubmissionsService } from 'src/app/submissions/_services/submissions.service';
import { SubmissionMethod } from 'src/app/submissions/_models/submission';
import { DiceService } from 'src/app/dice/_services/dice.service';
import { DiceQuoteMethod } from 'src/app/dice/_models/dice-quote';
import { CommonService } from 'src/app/_services/common.service';

@Injectable()
export class TypeaheadHTTPService {
  constructor(private http: HttpClient) {}

  /*
    *Typeahead API repsonse should always return as Array object
  */
  
  searchBusiness(psiAPI:string, term: string, state: string){
    if (term === '' || term.length < PRODUCT_CONFIG.businessLookupTypeLength) {
      return of([]);
    }
    else if(term.length > 30){
      term = term.slice(0, 30);
    }
    return this.http.get(psiAPI, {
      params: { searchTerm: term, candidateMaximumQuantity: PRODUCT_CONFIG.maxDnbExpectedResultCount.toString(), countryISOAlpha2Code: 'US', addressRegion: state, isOutOfBusiness: 'false' }
    }).pipe(
        map((response:any) => {
          let _res = [
            response
          ]
          return _res;
        })
      );
  }

  searchCode(psiAPI:string, term: string) {
    if (term === '' || term.length < PRODUCT_CONFIG.typeaheadTypeLength) {
      return of([]);
    }
    return this.http
      .get(psiAPI + term).pipe(
        map((response:any) => {
          //response.result;
          if(response.result.length == 0) 
            return [{desc: SUBMISSION_MSGS.NoCodesFound,
              code: "",
              minorName: "",
              subClassCode: "",
              subClassName: "",
              disabled: true}];
          else
            return response.result;
        })
      );
    }
  } 
  

@Component({
  selector: 'psi-typeahead',
  templateUrl: './typeahead.component.html',
  providers: [TypeaheadHTTPService],
  styles: ['./typeahead.component.scss']
})
export class TypeaheadComponent implements OnChanges, OnInit {
  code: any;
  business: any;
  searching = false;
  searchFailed = false;
  validSearchTerm = false;

  private searchResult: any = [];
  private submissionSteps = SubmissionSteps;
  private SUBMISSION_MSGS = SUBMISSION_MSGS;
  private submissionMethod: SubmissionMethod = new SubmissionMethod();
  private diceQuoteMethod: DiceQuoteMethod = new DiceQuoteMethod();
  private businessAddress;
  private stateSelected: any;
  private actualSearchResult: any;

  @Input() isBusinessLookup: boolean;
  @Input() isDice: boolean;
  @Input() psiModel: any;
  @Input() psiLabel: string;
  @Input() psiID: string;
  @Input() psiPlaceholder: string = "Search";
  @Input() psiHelpText: string = "";
  @Input() psiAPI: string = "";
  @Input() psiResultInput: boolean = false;
  @Input() isInvalid: boolean = false;
  @Input() isPercentInvalid: boolean = false;
  @Input() isPercentInvalidZero: boolean = false;
  @Input() businessStateSelected: any;
  @Input() referenceData: any;
  @Input() dnbEventsModel: any;

  @Output() isBusinessLookupOutput = new EventEmitter<boolean>();
  
  constructor(private _service: TypeaheadHTTPService, private submissionService: SubmissionsService, private diceService: DiceService, private commonService: CommonService) {
  }

  ngOnInit(){
    if(this.isBusinessLookup){
      if(!this.isDice) {
        this.businessAddress = this.submissionMethod.getBusinessAddress(this.psiModel);
      } else {
        this.businessAddress = this.diceQuoteMethod.getBusinessAddress(this.psiModel);
      }
    }

    console.log("this.dnbEventsModel :: ", this.dnbEventsModel);
  }

  ngOnChanges() {
    this.searchResult = [];
    this.searching = false;
    this.business = "";
    this.validSearchTerm = false;
  }

  get selectedStep(){
    return this.submissionService.selectedStep;
  }

  getStateAbbreviation(_stateName){
    return this.referenceData.states.find(_state=> {return _state.stateName.toLowerCase() == _stateName.toLowerCase()}).abbreviation;
  }

  search = ()=> {
     if(this.isBusinessLookup) {
      return this.searchBusiness;
    } else  {
      return this.searchCode;
    }
  }

  filterBusinesses = (item) => {
    if(item.organization.primaryAddress.streetAddress && item.organization.primaryAddress.streetAddress.line1 && item.organization.primaryAddress.addressLocality.name && item.organization.primaryAddress.addressRegion.name && item.organization.primaryAddress.postalCode){
      return true;
    }
    return false;
  }

  selectedItem=(item, input)=>{

    if(this.isBusinessLookup) {
      return this.selectedBusiness(item, input);
    } else  {
      return this.selectedCode(item, input);
    }    
  }

  searchBusiness = (text$: Observable<string>) => 
  text$.pipe(
    debounceTime(500),
    distinctUntilChanged(),
    tap(() => {this.searchResult = []; this.searching = true}),
    switchMap(term =>
      this._service.searchBusiness(this.psiAPI, term, this.businessStateSelected).pipe(
        tap((_result) => {
          let _searchResult: any = [];
          this.actualSearchResult = _result[0];
          this.validSearchTerm = term.length >= PRODUCT_CONFIG.businessLookupTypeLength;
          this.searchFailed = false; 
          this.searching = false;
          _searchResult = this.actualSearchResult.searchCandidates.filter(this.filterBusinesses);
          this.searchResult = _searchResult.slice(0,5);
          
          if(this.searchResult.length && this.validSearchTerm)  this.setDnBEvent(this.actualSearchResult, _searchResult.length, term);
        }),
        catchError((_errResponse) => {
          console.log('In typeahead error !!');
          this.validSearchTerm = term.length >= PRODUCT_CONFIG.businessLookupTypeLength;
          this.searchFailed = true;
          this.searching = false;
          this.searchResult = [];
          if(this.validSearchTerm) this.setDnBEvent(_errResponse.error, this.searchResult, term);
          return this.searchResult;
        }),  
        finalize(() => {
          this.validSearchTerm = term.length >= PRODUCT_CONFIG.businessLookupTypeLength;
          this.searching = false;
        }))
    ),
    tap(() => {this.searching = false;})
  )

  selectedBusiness = (item, input)=>{
    if(item != null){
      if(!this.isDice) {
        this.psiModel.submissionData.thirdPartyKey = item.organization.duns;
        this.psiModel.submissionData.accountName = item.organization.primaryName;
        if(item.organization.tradeStyleNames && item.organization.tradeStyleNames.length > 0){
          this.psiModel.submissionData.accountDBAName = item.organization.tradeStyleNames[0].name;
        }
        this.businessAddress.addressLine1 = item.organization.primaryAddress.streetAddress.line1;
        if(item.organization.primaryAddress.streetAddress && item.organization.primaryAddress.streetAddress.line2){
          this.businessAddress.addressLine2 = item.organization.primaryAddress.streetAddress.line2;
        }
        this.businessAddress.city = item.organization.primaryAddress.addressLocality.name;
        this.businessAddress.zip = item.organization.primaryAddress.postalCode;
        this.businessAddress.country = item.organization.primaryAddress.addressCountry.name;
      } else { // Selected Business for Submission 
        this.psiModel.thirdPartyKey = item.organization.duns;
        this.psiModel.accountName = item.organization.primaryName;
        if(item.organization.tradeStyleNames && item.organization.tradeStyleNames.length > 0){
          this.psiModel.accountDBAName = item.organization.tradeStyleNames[0].name;
        }
        this.businessAddress.addressLine1 = item.organization.primaryAddress.streetAddress.line1;
        if(item.organization.primaryAddress.streetAddress && item.organization.primaryAddress.streetAddress.line2){
          this.businessAddress.addressLine2 = item.organization.primaryAddress.streetAddress.line2;
        }
        this.businessAddress.city = item.organization.primaryAddress.addressLocality.name;
        this.businessAddress.zip = item.organization.primaryAddress.postalCode;
        this.businessAddress.country = item.organization.primaryAddress.addressCountry.name;
      }

      this.dnbEventsModel.eventType = DandBEventsTypes.Choice;
      this.dnbEventsModel.results = [];
      this.dnbEventsModel.choiceIndex = item.displaySequence;
      this.dnbEventsModel.choice = item;
      this.dnbEventsModel.thirdPartyTransId = this.actualSearchResult.transactionDetail.transactionID;

    } else {
      //For DNB Event When we pick Didn't find a match
      this.dnbEventsModel.eventType = DandBEventsTypes.Choice;
      this.dnbEventsModel.results = [];
      this.dnbEventsModel.choiceIndex = 0;
      this.dnbEventsModel.choice = null;
    }

    this.dnbEventLog(this.dnbEventsModel);
    this.businessAddress.state = this.businessStateSelected;    
    console.log(this.psiModel);
    input.value="";
    this.searchResult = [];

    
    this.isBusinessLookupOutput.emit(false);
  }

  searchCode = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => {this.searchResult = []; this.searching = true;}),
      switchMap(term =>
        this._service.searchCode(this.psiAPI, term).pipe(
          tap((_result) => {
            this.searchFailed = false; 
            this.searching = false; 
            if(_result && (_result.length > 1 || (_result.length == 1 && _result[0].disabled == false))){
              _result.map(r=>r.disabled = false);
            }
            this.searchResult = _result;
          }),
          catchError(() => {
            this.searchFailed = true;
            this.searching = false;
            this.searchResult = [{desc: SUBMISSION_MSGS.NoCodesFound,
              code: "",
              minorName: "",
              subClassCode: "",
              subClassName: "",
              disabled: true}];
            return this.searchResult;
          }),  
          finalize(() => {
            this.searching = false;
          }))
      ),
      tap(() => this.searching = false)
    )

  selectedCode = (item, input)=>{
    // $event.preventDefault();
    console.log(input.value);
    if(!item.disabled){
      if(this.psiResultInput){
        item.percent = this.psiModel.length==0?100:0;
      }
      this.psiModel.push(item);
      this.code="";
      input.value="";
      console.log(input.value);
      this.searchResult = [];
      input.focus();
    }
  }

  removeItem = (index)=>{
    console.log(index);
    this.psiModel.splice(index,1);
  }

  setDnBEvent(_typeaheadResult, _filteredSearchLen, _searchTerm) {
    this.dnbEventsModel.eventType = DandBEventsTypes.Typeahead;
    this.dnbEventsModel.inCompleteResultCount = (_typeaheadResult && _typeaheadResult.searchCandidates) ? (_typeaheadResult.searchCandidates.length - _filteredSearchLen) : 0;
    this.dnbEventsModel.searchTerm =  _searchTerm;
    this.dnbEventsModel.filterCriteria.addressRegion = this.businessStateSelected;
    this.dnbEventsModel.thirdPartyTransId = (_typeaheadResult && _typeaheadResult.transactionDetail && _typeaheadResult.transactionDetail.transactionID) ? _typeaheadResult.transactionDetail.transactionID : null;
    this.dnbEventsModel.returnResultCount = (_typeaheadResult && _typeaheadResult.searchCandidates) ? _typeaheadResult.searchCandidates.length : 0;
    this.dnbEventsModel.results = (_typeaheadResult && _typeaheadResult.searchCandidates) ? _typeaheadResult.searchCandidates : [];

    console.log('this.dnbEventsModel :: ', this.dnbEventsModel);

    this.dnbEventLog(this.dnbEventsModel);
  }

  dnbEventLog(_data) {
    this.commonService.setdandbevent(_data).subscribe((data:any) => {
      console.log('Typeahead :: event fired', data);
    });
    this.commonService.storeDnBEventData(_data);
  }
}